/* ADVELLO theme JS: menu, cart drawer, AJAX add-to-cart, variant selection, quantity controls. */
(function () {
  "use strict";

  var ADVELLO = window.ADVELLO || {};
  var ROUTES = ADVELLO.routes || {};
  var S = ADVELLO.strings || {};

  // All cart endpoints derive from Liquid's `routes` object so they keep working
  // under Shopify Markets locale/country URL prefixes (/en-de/, /en-us/).
  var CART_URL = ROUTES.cart || "/cart";
  var CART_ADD_URL = ROUTES.cartAdd || "/cart/add";
  var CART_CHANGE_URL = ROUTES.cartChange || "/cart/change";

  function t(key, fallback) {
    var value = S[key];
    return typeof value === "string" && value.length ? value : fallback;
  }

  var themeStorageKey = "advello-color-mode";
  var systemTheme = window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;

  // Section-owned elements are re-queried on demand rather than cached at load,
  // so a theme-editor section re-render never leaves us holding detached nodes.
  function menuEl() { return document.querySelector("[data-menu]"); }
  function drawerEl() { return document.querySelector("[data-cart-drawer]"); }
  function chatPanelEl() { return document.querySelector("#adv-chat-panel"); }
  function chatLaunchEl() { return document.querySelector(".adv-chat-launch"); }

  /* ---------------------------------------------------------------- theme */

  function syncThemeControls() {
    var isDark = document.documentElement.dataset.theme === "dark";
    var label = isDark ? t("switchToLight", "Switch to light theme") : t("switchToDark", "Switch to dark theme");
    Array.prototype.forEach.call(document.querySelectorAll("[data-theme-toggle]"), function (button) {
      button.setAttribute("aria-pressed", isDark ? "true" : "false");
      button.setAttribute("aria-label", label);
      button.setAttribute("title", label);
    });
  }

  function applyTheme(theme, preference, persist) {
    var nextTheme = theme === "dark" ? "dark" : "light";
    var root = document.documentElement;
    root.dataset.theme = nextTheme;
    root.dataset.themePreference = preference || nextTheme;
    root.style.colorScheme = nextTheme;
    var themeMeta = document.querySelector("[data-browser-theme-color]");
    if (themeMeta) themeMeta.content = nextTheme === "dark" ? "#0b0e0d" : "#ffffff";
    if (persist) {
      try { window.localStorage.setItem(themeStorageKey, nextTheme); } catch (error) {}
    }
    syncThemeControls();
  }

  function toggleTheme() {
    var nextTheme = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
    applyTheme(nextTheme, nextTheme, true);
  }

  syncThemeControls();
  if (systemTheme) {
    var followSystemTheme = function (event) {
      if (document.documentElement.dataset.themePreference === "system") {
        applyTheme(event.matches ? "dark" : "light", "system", false);
      }
    };
    if (typeof systemTheme.addEventListener === "function") systemTheme.addEventListener("change", followSystemTheme);
    else if (typeof systemTheme.addListener === "function") systemTheme.addListener(followSystemTheme);
  }

  /* --------------------------------------------------- overlays / focus */

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // Scroll lock is reference-counted, so overlapping overlays cannot unlock the
  // page early or leave it permanently locked.
  var scrollLocks = 0;
  var savedOverflow = "";
  function lockScroll() {
    if (scrollLocks === 0) {
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    scrollLocks += 1;
  }
  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (scrollLocks === 0) document.body.style.overflow = savedOverflow;
  }

  function focusableIn(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (node) {
      return node.offsetParent !== null || node === document.activeElement;
    });
  }

  function trapTab(el, event) {
    if (event.key !== "Tab") return;
    var nodes = focusableIn(el);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  var openOverlays = [];

  function overlayControl(el) {
    if (!el) return null;
    if (el === menuEl()) return document.querySelector("[data-menu-open]");
    if (el === drawerEl()) return document.querySelector("[data-cart-open]");
    return null;
  }

  function openOverlay(el) {
    if (!el || !el.hidden) return;
    el.hidden = false;
    lockScroll();
    var control = overlayControl(el);
    if (control) control.setAttribute("aria-expanded", "true");
    var record = { el: el, previousFocus: document.activeElement };
    record.keyHandler = function (event) { trapTab(el, event); };
    el.addEventListener("keydown", record.keyHandler);
    openOverlays.push(record);
    var closeButton = el.querySelector("[data-menu-close], [data-cart-close]");
    var target = closeButton || focusableIn(el)[0];
    if (target) window.setTimeout(function () { target.focus(); }, 0);
  }

  function closeOverlay(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    unlockScroll();
    var control = overlayControl(el);
    if (control) control.setAttribute("aria-expanded", "false");
    for (var i = openOverlays.length - 1; i >= 0; i -= 1) {
      if (openOverlays[i].el !== el) continue;
      var record = openOverlays.splice(i, 1)[0];
      el.removeEventListener("keydown", record.keyHandler);
      var back = control || record.previousFocus;
      if (back && typeof back.focus === "function" && document.contains(back)) back.focus();
      break;
    }
  }

  function closeChat(returnFocus) {
    var panel = chatPanelEl();
    var launch = chatLaunchEl();
    if (panel) panel.hidden = true;
    if (launch) {
      launch.setAttribute("aria-expanded", "false");
      if (returnFocus) launch.focus();
    }
  }

  document.addEventListener("click", function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== "function") return;

    if (target.closest("[data-theme-toggle]")) toggleTheme();
    if (target.closest("[data-menu-open]")) { closeOverlay(drawerEl()); openOverlay(menuEl()); }
    if (target.closest("[data-menu-close]")) closeOverlay(menuEl());
    if (target.closest("[data-cart-open]")) { e.preventDefault(); closeOverlay(menuEl()); openOverlay(drawerEl()); }
    if (target.closest("[data-cart-close]")) closeOverlay(drawerEl());

    if (target.closest(".adv-chat-launch")) {
      var panel = chatPanelEl();
      var launch = chatLaunchEl();
      if (panel) panel.hidden = false;
      if (launch) launch.setAttribute("aria-expanded", "true");
    }
    if (target.closest(".adv-chat-close")) closeChat(true);

    if (target === menuEl()) closeOverlay(menuEl());
    if (target === drawerEl()) closeOverlay(drawerEl());

    // Cart-page removal: convert the fallback link into a POST.
    var removeLink = target.closest("[data-cart-remove]");
    if (removeLink) {
      var removeLine = Number(removeLink.dataset.line);
      if (removeLine) {
        e.preventDefault();
        removeLink.setAttribute("aria-disabled", "true");
        fetch(CART_CHANGE_URL + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: removeLine, quantity: 0 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error("remove");
            window.location.reload();
          })
          .catch(function () { window.location.href = removeLink.href; });
        return;
      }
    }

    var qtyBtn = target.closest("[data-qty-change]");
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn);
      return;
    }

    var stepper = target.closest("[data-qty-minus], [data-qty-plus]");
    if (stepper) {
      var isPlus = stepper.hasAttribute("data-qty-plus");
      var wrap = stepper.closest(".quantity") || stepper.parentElement;
      var input = wrap && wrap.querySelector('input[name="quantity"]');
      if (!input) return;
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = 1;
      input.value = Math.max(1, current + (isPlus ? 1 : -1));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var drawer = drawerEl();
    var menu = menuEl();
    if (drawer && !drawer.hidden) { closeOverlay(drawer); return; }
    if (menu && !menu.hidden) { closeOverlay(menu); return; }
    var panel = chatPanelEl();
    if (panel && !panel.hidden) closeChat(true);
  });

  /* ------------------------------------------------------ marquee pause */

  function initMarquee(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll("[data-marquee]"), function (marquee) {
      if (marquee.dataset.marqueeReady === "true") return;
      marquee.dataset.marqueeReady = "true";
      var button = marquee.querySelector("[data-marquee-toggle]");
      if (!button) return;
      button.addEventListener("click", function () {
        var paused = marquee.classList.toggle("is-paused");
        button.setAttribute("aria-pressed", paused ? "true" : "false");
        var label = paused ? t("playAnimation", "Play animation") : t("pauseAnimation", "Pause animation");
        button.setAttribute("aria-label", label);
        button.setAttribute("title", label);
      });
    });
  }

  /* ---------------------------------------------------- product gallery */

  function optionButtons(root, index) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-option-index="' + index + '"]'));
  }

  function setButtonState(root, index, value) {
    optionButtons(root, index).forEach(function (button) {
      var selected = button.dataset.optionValue === value;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-checked", selected ? "true" : "false");
      button.tabIndex = selected ? 0 : -1;
    });
  }

  function activateGalleryMedia(root, mediaId) {
    var target = null;
    if (mediaId) target = root.querySelector('[data-gallery-slide][data-media-id="' + String(mediaId) + '"]');
    // Fall back to the first slide so a variant with no mapping never leaves the
    // previous variant's image on screen.
    if (!target) target = root.querySelector("[data-gallery-slide]");
    if (!target) return;
    var id = target.dataset.mediaId;

    Array.prototype.forEach.call(root.querySelectorAll("[data-gallery-slide]"), function (slide) {
      slide.hidden = slide !== target;
      if (slide !== target) {
        Array.prototype.forEach.call(slide.querySelectorAll("video"), function (video) { video.pause(); });
      }
    });
    Array.prototype.forEach.call(root.querySelectorAll("[data-gallery-thumb]"), function (thumb) {
      var active = thumb.dataset.mediaId === id;
      thumb.classList.toggle("is-active", active);
      thumb.setAttribute("aria-pressed", active ? "true" : "false");
      if (active && root.dataset.galleryReady === "true") {
        var track = thumb.parentElement;
        if (track && track.scrollWidth > track.clientWidth && typeof track.scrollTo === "function") {
          track.scrollTo({
            left: thumb.offsetLeft - (track.clientWidth - thumb.clientWidth) / 2,
            behavior: "smooth"
          });
        }
      }
    });
  }

  function galleryMediaIdByAltKey(root, key) {
    if (!key) return "";
    var media = root.querySelector('[data-gallery-slide][data-media-alt-key="' + key + '"]');
    return media ? media.dataset.mediaId : "";
  }

  function variantMediaId(root, variant, preferredIndex) {
    if (!variant) return root.dataset.defaultMediaId || "";

    // Shopify's assigned variant media is authoritative and may be an image,
    // video, external video or 3D model.
    if (variant.dataset.mediaId && root.querySelector('[data-gallery-slide][data-media-id="' + variant.dataset.mediaId + '"]')) {
      return variant.dataset.mediaId;
    }

    // Safe fallback for shops that label media instead of assigning it to each
    // variant: use an exact variant-title label first (for example "White / M").
    var titleKey = variant.dataset.variantTitleKey || "";
    var exactTitleMedia = galleryMediaIdByAltKey(root, "variant-" + titleKey) || galleryMediaIdByAltKey(root, titleKey);
    if (exactTitleMedia) return exactTitleMedia;

    // A namespaced label can intentionally share one image across variants,
    // for example "Colour White", "Size M" or "Style Quilted".
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-option-group]"));
    groups.sort(function (a, b) {
      if (String(a.dataset.optionGroup) === String(preferredIndex)) return -1;
      if (String(b.dataset.optionGroup) === String(preferredIndex)) return 1;
      return Number(a.dataset.optionGroup) - Number(b.dataset.optionGroup);
    });
    for (var i = 0; i < groups.length; i += 1) {
      var index = groups[i].dataset.optionGroup;
      var nameKey = groups[i].dataset.optionNameKey;
      var valueKey = variant.dataset["optionKey-" + index];
      var optionMedia = galleryMediaIdByAltKey(root, nameKey && valueKey ? nameKey + "-" + valueKey : "");
      if (optionMedia) return optionMedia;
    }

    // Never leave a previous variant's image visible when this variant has no
    // mapping. Return to the product's default media instead.
    return root.dataset.defaultMediaId || "";
  }

  function updateVariantUrl(root, variantId) {
    if (!variantId || !window.history || typeof window.history.replaceState !== "function") return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  /* ------------------------------------------------------- product zoom */

  function initProductZoom(root) {
    var lightbox = root.querySelector("[data-product-lightbox]");
    if (!lightbox || lightbox.dataset.zoomReady === "true") return;
    var stage = lightbox.querySelector("[data-product-zoom-stage]");
    var zoomImage = lightbox.querySelector("[data-product-zoom-image]");
    var closeButton = lightbox.querySelector(".product-lightbox-close");
    var zoomIn = lightbox.querySelector("[data-product-zoom-in]");
    var zoomOut = lightbox.querySelector("[data-product-zoom-out]");
    var zoomReset = lightbox.querySelector("[data-product-zoom-reset]");
    if (!stage || !zoomImage) return;
    lightbox.dataset.zoomReady = "true";

    var scale = 1;
    var offsetX = 0;
    var offsetY = 0;
    var previousFocus = null;
    var pointers = new Map();
    var lastCenter = null;
    var lastDistance = null;
    var gestureMoved = false;
    var pinching = false;
    var lastTap = 0;

    function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }

    function applyZoom() {
      scale = clamp(scale, 1, 5);
      if (scale === 1) {
        offsetX = 0;
        offsetY = 0;
      } else {
        var maxX = stage.clientWidth * (scale - 1) / 2;
        var maxY = stage.clientHeight * (scale - 1) / 2;
        offsetX = clamp(offsetX, -maxX, maxX);
        offsetY = clamp(offsetY, -maxY, maxY);
      }
      zoomImage.style.transform = "translate3d(" + offsetX + "px," + offsetY + "px,0) scale(" + scale + ")";
    }

    function changeZoom(amount) {
      scale = clamp(scale + amount, 1, 5);
      applyZoom();
    }

    function resetZoom() {
      scale = 1;
      offsetX = 0;
      offsetY = 0;
      applyZoom();
    }

    function openZoom(trigger) {
      if (!trigger || !trigger.dataset.zoomSrc) return;
      previousFocus = document.activeElement;
      zoomImage.src = trigger.dataset.zoomSrc;
      zoomImage.alt = trigger.dataset.zoomAlt || "";
      lightbox.hidden = false;
      lockScroll();
      resetZoom();
      if (closeButton) closeButton.focus();
    }

    function closeZoom() {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      zoomImage.removeAttribute("src");
      unlockScroll();
      pointers.clear();
      if (previousFocus && typeof previousFocus.focus === "function" && document.contains(previousFocus)) previousFocus.focus();
    }

    Array.prototype.forEach.call(root.querySelectorAll("[data-product-zoom-open]"), function (trigger) {
      trigger.addEventListener("click", function () { openZoom(trigger); });
      trigger.addEventListener("pointermove", function (event) {
        if (event.pointerType !== "mouse") return;
        var rect = trigger.getBoundingClientRect();
        var image = trigger.querySelector(".product-main-image");
        if (!image) return;
        image.style.setProperty("--zoom-x", ((event.clientX - rect.left) / rect.width * 100) + "%");
        image.style.setProperty("--zoom-y", ((event.clientY - rect.top) / rect.height * 100) + "%");
      });
    });

    Array.prototype.forEach.call(lightbox.querySelectorAll("[data-product-zoom-close]"), function (button) {
      button.addEventListener("click", closeZoom);
    });
    if (zoomIn) zoomIn.addEventListener("click", function () { changeZoom(0.5); });
    if (zoomOut) zoomOut.addEventListener("click", function () { changeZoom(-0.5); });
    if (zoomReset) zoomReset.addEventListener("click", resetZoom);

    stage.addEventListener("wheel", function (event) {
      event.preventDefault();
      changeZoom(event.deltaY < 0 ? 0.35 : -0.35);
    }, { passive: false });

    function pointerCenter() {
      var values = Array.from(pointers.values());
      if (!values.length) return null;
      return {
        x: values.reduce(function (sum, point) { return sum + point.x; }, 0) / values.length,
        y: values.reduce(function (sum, point) { return sum + point.y; }, 0) / values.length
      };
    }

    function pointerDistance() {
      var values = Array.from(pointers.values());
      if (values.length < 2) return null;
      return Math.hypot(values[0].x - values[1].x, values[0].y - values[1].y);
    }

    stage.addEventListener("pointerdown", function (event) {
      stage.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      lastCenter = pointerCenter();
      lastDistance = pointerDistance();
      gestureMoved = false;
      if (pointers.size > 1) pinching = true;
    });

    stage.addEventListener("pointermove", function (event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      var center = pointerCenter();
      if (!center || !lastCenter) return;
      var movementX = center.x - lastCenter.x;
      var movementY = center.y - lastCenter.y;
      if (Math.abs(movementX) + Math.abs(movementY) > 2) gestureMoved = true;
      offsetX += movementX;
      offsetY += movementY;

      var distance = pointerDistance();
      if (distance && lastDistance) {
        scale = clamp(scale * (distance / lastDistance), 1, 5);
        gestureMoved = true;
      }
      lastCenter = center;
      lastDistance = distance;
      applyZoom();
    });

    function finishPointer(event) {
      var wasTap = event.pointerType === "touch" && !gestureMoved && !pinching;
      pointers.delete(event.pointerId);
      lastCenter = pointerCenter();
      lastDistance = pointerDistance();
      if (!pointers.size) {
        if (wasTap) {
          var now = Date.now();
          if (now - lastTap < 320) {
            scale = scale > 1 ? 1 : 2.5;
            applyZoom();
            lastTap = 0;
          } else {
            lastTap = now;
          }
        }
        pinching = false;
        gestureMoved = false;
      }
    }

    stage.addEventListener("pointerup", finishPointer);
    stage.addEventListener("pointercancel", finishPointer);
    stage.addEventListener("dblclick", function () {
      scale = scale > 1 ? 1 : 2.5;
      applyZoom();
    });
    window.addEventListener("resize", function () {
      if (document.contains(lightbox) && !lightbox.hidden) applyZoom();
    });
    lightbox.addEventListener("keydown", function (event) {
      if (event.key === "Escape") { closeZoom(); return; }
      trapTab(lightbox, event);
    });
  }

  /* --------------------------------------------------- variant matching */

  function selectedValues(root) {
    var values = {};
    var select = root.querySelector("[data-variant-select]");
    var selectedOption = select && select.options[select.selectedIndex];
    Array.prototype.forEach.call(root.querySelectorAll("[data-option-group]"), function (group) {
      var index = group.dataset.optionGroup;
      var selected = group.querySelector('[data-option-index="' + index + '"][aria-checked="true"]');
      if (selected) {
        values[index] = selected.dataset.optionValue;
        return;
      }
      // A group with no checked button must still constrain the match, otherwise
      // an unrendered option value silently resolves to the wrong variant.
      if (selectedOption && selectedOption.dataset["option-" + index]) {
        values[index] = selectedOption.dataset["option-" + index];
      }
    });
    return values;
  }

  function optionMatches(option, values) {
    return Object.keys(values).every(function (index) {
      return option.dataset["option-" + index] === values[index];
    });
  }

  function selectedStyle(root) {
    var style = "";
    Array.prototype.forEach.call(root.querySelectorAll("[data-option-group]"), function (group) {
      var legend = group.querySelector("legend");
      if (!legend || legend.textContent.trim().toLowerCase() !== "style") return;
      var checked = group.querySelector('[aria-checked="true"]');
      if (checked) style = checked.dataset.optionValue || "";
    });
    return style;
  }

  function updateProductDetails(root) {
    var style = selectedStyle(root);
    Array.prototype.forEach.call(root.querySelectorAll("[data-style-panel]"), function (panel) {
      panel.hidden = !!style && panel.dataset.stylePanel !== style;
    });
  }

  function setStatus(root, message) {
    var status = root.querySelector("[data-variant-status]");
    if (status) status.textContent = message;
  }

  function clearFormError(form) {
    if (!form) return;
    var box = form.querySelector("[data-form-error]");
    if (box) {
      box.textContent = "";
      box.hidden = true;
    }
  }

  function showFormError(form, message) {
    if (!form) return;
    var box = form.querySelector("[data-form-error]");
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function syncVariant(root, preferredIndex, preferredValue, userInitiated) {
    var select = root.querySelector("[data-variant-select]");
    if (!select) { updateProductDetails(root); return; }
    var variants = Array.prototype.slice.call(select.options);
    var values = selectedValues(root);
    var match = variants.find(function (option) { return optionMatches(option, values); });
    if (!match && preferredIndex) {
      match = variants.find(function (option) {
        return option.dataset["option-" + preferredIndex] === preferredValue && option.dataset.available === "true";
      }) || variants.find(function (option) { return option.dataset["option-" + preferredIndex] === preferredValue; });
    }
    if (!match) match = variants.find(function (option) { return option.dataset.available === "true"; }) || variants[0];
    if (!match) return;

    select.value = match.value;
    [1, 2, 3].forEach(function (index) {
      var value = match.dataset["option-" + index];
      if (value) setButtonState(root, index, value);
    });

    var available = match.dataset.available === "true";
    var price = root.querySelector("[data-price]");
    var comparePrice = root.querySelector("[data-compare-price]");
    var saleLabel = root.querySelector("[data-sale-label]");
    var priorNote = root.querySelector("[data-prior-price-note]");
    var stock = root.querySelector("[data-stock]");
    var stockText = root.querySelector("[data-stock-text]");
    var add = root.querySelector("[data-add-button]");
    var buy = root.querySelector("[data-buy-button]");

    if (price) price.textContent = match.dataset.price || "";
    var hasCompare = !!match.dataset.comparePrice;
    if (comparePrice) {
      comparePrice.textContent = match.dataset.comparePrice || "";
      comparePrice.hidden = !hasCompare;
    }
    if (saleLabel) {
      saleLabel.textContent = match.dataset.savingPercent
        ? t("save", "Save __PCT__%").replace("__PCT__", match.dataset.savingPercent)
        : "";
      saleLabel.hidden = !match.dataset.savingPercent;
    }
    if (priorNote) priorNote.hidden = !hasCompare;
    if (stock) stock.classList.toggle("stock-out", !available);
    if (stockText) stockText.textContent = available ? t("inStock", "In stock") : t("outOfStock", "Out of stock");
    if (add) {
      add.disabled = !available;
      setActionLabel(add, available ? t("addToCart", "Add to cart") : t("soldOut", "Sold out"));
    }
    if (buy) buy.disabled = !available;

    activateGalleryMedia(root, variantMediaId(root, match, preferredIndex));
    root.dataset.selectedVariantId = match.value;

    if (userInitiated) {
      var title = match.dataset.variantTitle || "";
      var template = available
        ? t("variantSelected", "{{ variant }} selected.")
        : t("variantSelectedSoldOut", "{{ variant }} selected, currently sold out.");
      setStatus(root, template.replace("{{ variant }}", title));
      updateVariantUrl(root, match.value);
      root.dispatchEvent(new CustomEvent("variant:change", {
        bubbles: true,
        detail: { variantId: match.value, available: available }
      }));
    }
    clearFormError(root.querySelector(".product-form"));
    updateProductDetails(root);
  }

  // Roving-tabindex arrow-key navigation for the radio-style option groups.
  function handleOptionKeydown(root, event) {
    if (!event.target || typeof event.target.closest !== "function") return;
    var button = event.target.closest("[data-option-index]");
    if (!button) return;
    var keys = ["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp", "Home", "End"];
    if (keys.indexOf(event.key) === -1) return;
    var group = button.closest("[data-option-group]");
    if (!group) return;
    var buttons = Array.prototype.filter.call(
      group.querySelectorAll("[data-option-index]"),
      function (node) { return !node.disabled; }
    );
    if (buttons.length < 2) return;
    event.preventDefault();
    var current = buttons.indexOf(button);
    var next;
    if (event.key === "Home") next = 0;
    else if (event.key === "End") next = buttons.length - 1;
    else if (event.key === "ArrowRight" || event.key === "ArrowDown") next = (current + 1) % buttons.length;
    else next = (current - 1 + buttons.length) % buttons.length;
    var target = buttons[next];
    target.focus();
    setButtonState(root, target.dataset.optionIndex, target.dataset.optionValue);
    syncVariant(root, target.dataset.optionIndex, target.dataset.optionValue, true);
  }

  function initProduct(root) {
    if (root.dataset.advReady === "true") return;
    root.dataset.advReady = "true";

    root.addEventListener("click", function (event) {
      if (!event.target || typeof event.target.closest !== "function") return;
      var thumbnail = event.target.closest("[data-gallery-thumb]");
      if (thumbnail) {
        activateGalleryMedia(root, thumbnail.dataset.mediaId);
        return;
      }
      var button = event.target.closest("[data-option-index]");
      if (!button || button.disabled) return;
      var index = button.dataset.optionIndex;
      var value = button.dataset.optionValue;
      setButtonState(root, index, value);
      syncVariant(root, index, value, true);
    });

    root.addEventListener("keydown", function (event) { handleOptionKeydown(root, event); });

    // The .sr-only <select> is keyboard- and screen-reader-reachable and is the
    // element that carries name="id" into the form, so it must drive the display
    // instead of silently disagreeing with it.
    var select = root.querySelector("[data-variant-select]");
    if (select) {
      select.addEventListener("change", function () {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        [1, 2, 3].forEach(function (index) {
          var value = option.dataset["option-" + index];
          if (value) setButtonState(root, index, value);
        });
        syncVariant(root, null, null, true);
      });
    }

    initProductZoom(root);
    syncVariant(root);
    root.dataset.galleryReady = "true";
  }

  /* ---------------------------------------------------------- cart AJAX */

  function announceCart(message) {
    var region = document.querySelector("[data-cart-status]");
    if (region) region.textContent = message;
  }

  function setCartCount(count) {
    Array.prototype.forEach.call(document.querySelectorAll("[data-cart-count]"), function (el) {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  // The drawer fragment carries the item count, so there is no separate /cart.js trip.
  function refreshDrawer(openAfter, focusSelector) {
    return fetch(CART_URL + "?view=drawer", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) {
        if (!r.ok) throw new Error("drawer");
        return r.text();
      })
      .then(function (html) {
        var target = document.querySelector("[data-cart-contents]");
        if (!target) return;
        target.innerHTML = html;
        var counter = target.querySelector("[data-cart-item-count]");
        if (counter) setCartCount(counter.dataset.cartItemCount || "0");
        if (openAfter) openOverlay(drawerEl());
        if (focusSelector) {
          var restored = target.querySelector(focusSelector);
          if (restored) restored.focus();
        } else if (openAfter !== true) {
          var heading = document.querySelector("[data-cart-drawer] .drawer-head [data-cart-close]");
          if (heading) heading.focus();
        }
      })
      .catch(function () {
        if (openAfter) window.location.href = CART_URL;
      });
  }

  function changeLine(button) {
    if (button.dataset.busy === "true") return;
    var line = Number(button.dataset.line);
    if (!line) return;

    // Read the live quantity from the DOM at click time rather than trusting a
    // value baked in at render. The row is locked for the duration of the request
    // so two clicks can never compute from the same stale number.
    var row = button.closest(".qty-row");
    var display = row && row.querySelector("[data-qty-value]");
    var nextQty;
    if (button.dataset.qtyAbsolute === "true") {
      nextQty = Number(button.dataset.qty) || 0;
    } else {
      var currentQty = display ? Number(display.dataset.qtyValue) : NaN;
      if (isNaN(currentQty)) currentQty = 1;
      var delta = Number(button.dataset.qtyDelta) || 0;
      nextQty = Math.max(0, currentQty + delta);
    }

    if (display) {
      display.dataset.qtyValue = String(nextQty);
      display.textContent = String(nextQty);
    }

    var siblings = row ? Array.prototype.slice.call(row.querySelectorAll("[data-qty-change]")) : [button];
    siblings.forEach(function (el) { el.dataset.busy = "true"; el.disabled = true; });

    fetch(CART_CHANGE_URL + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: nextQty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("change");
        return r.json();
      })
      .then(function () {
        announceCart(t("quantityUpdated", "Cart updated."));
        var selector = nextQty > 0
          ? '[data-qty-change][data-line="' + line + '"][data-qty-delta="' + (button.dataset.qtyDelta || "") + '"]'
          : null;
        return refreshDrawer(false, selector);
      })
      .catch(function () {
        announceCart(t("cartError", "Sorry, something went wrong. Please try again."));
        return refreshDrawer(false, null);
      })
      .then(function () {
        // Always re-enable: the row may not have been replaced if the refresh failed.
        siblings.forEach(function (el) { el.dataset.busy = "false"; el.disabled = false; });
      });
  }

  function setActionLabel(button, text) {
    if (!button) return;
    var label = button.querySelector("[data-action-label]");
    if (label) label.textContent = text;
    else button.textContent = text;
  }

  function setActionBusy(button, busy) {
    if (!button) return;
    button.classList.toggle("is-loading", busy);
    if (busy) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  document.addEventListener("submit", function (e) {
    if (!e.target || typeof e.target.closest !== "function") return;
    var form = e.target.closest("[data-ajax-add], .product-form");
    if (!form) return;

    // Let "Buy it now" and the dynamic payment buttons submit natively.
    // document.activeElement is the fallback for browsers without event.submitter.
    var submitter = e.submitter || document.activeElement;
    if (submitter && submitter.name === "checkout") return;
    if (submitter && typeof submitter.closest === "function" && submitter.closest(".shopify-payment-button")) return;

    e.preventDefault();
    clearFormError(form);

    var actionButton = submitter && form.contains(submitter) && submitter.type === "submit"
      ? submitter
      : form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
    var actionLabel = actionButton && actionButton.querySelector("[data-action-label]");
    var originalLabel = actionLabel ? actionLabel.textContent : t("addToCart", "Add to cart");

    setActionBusy(actionButton, true);
    setActionLabel(actionButton, t("adding", "Adding…"));

    fetch(CART_ADD_URL + ".js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error("cart");
            err.recoverable = r.status === 422;
            err.description = data && (data.description || data.message);
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        setActionBusy(actionButton, false);
        if (actionButton) actionButton.classList.add("is-added");
        setActionLabel(actionButton, t("added", "Added ✓"));
        announceCart(t("added", "Added ✓"));
        refreshDrawer(true, null);
        window.setTimeout(function () {
          if (actionButton) actionButton.classList.remove("is-added");
          setActionLabel(actionButton, originalLabel);
        }, 1600);
      })
      .catch(function (error) {
        setActionBusy(actionButton, false);
        setActionLabel(actionButton, originalLabel);
        // A 422 is a normal outcome (sold out, quantity limit). Show it in place
        // rather than navigating to Shopify's bare error page.
        if (error && error.recoverable) {
          var message = error.description || t("cartError", "Sorry, something went wrong. Please try again.");
          showFormError(form, message);
          announceCart(message);
          return;
        }
        form.submit();
      });
  });

  /* --------------------------------------------------------------- init */

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll("[data-adv-product]"), initProduct);
    initMarquee(root);
  }

  initAll(document);

  // The theme editor swaps section DOM without a page load.
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    // Only release overlays owned by the section that unloaded; zeroing global
    // state would unlock the page behind an overlay belonging to another section.
    for (var i = openOverlays.length - 1; i >= 0; i -= 1) {
      var el = openOverlays[i].el;
      if (event.target && event.target.contains && event.target.contains(el)) {
        openOverlays.splice(i, 1);
        unlockScroll();
      }
    }
  });
})();
